import { env } from './env'

export function checkIfProductionEnvironment(): boolean {
  return env.NODE_ENV === 'production' && env.PROJECT_ID === 'meru-health-us'
}
